import { useState } from "react";
import { useRouter } from "next/router";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog"
import { Button } from "../ui/button";
import ActivityService from "../../services/acitvity/activity.service";
import useSnackbar from "../../hooks/useSnackbar";
import { ROUTES } from "../../utils/constants";
import ThreeDotLoader from "../loader/three-dots-loader";

type Props = {
  open: boolean;
  customerId: number;
  setOpen: (val: boolean) => void;
  getNotesList: (refresh: boolean, id: number) => void 
}

const AddTextNoteModal = ({ open, setOpen, customerId, getNotesList }: Props) => {
  const { replace, asPath } = useRouter();
  const { showChangesSavedSnackbar } = useSnackbar();
  const [textNote, setTextNote] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const textAreaRef = (element: HTMLTextAreaElement | null) => {
    if (element) {
      setTimeout(() => element.focus(), 100);
    }
  }

  const addNote = async (id: number) => {
    try {
      setIsLoading(true);
      await ActivityService.createTextNote({
        customer_id: id,
        note: textNote
      });
      if (asPath.includes('insights')) {
        await getNotesList(true, customerId);
        replace(`/${ROUTES.INSIGHTS.L2}/${customerId}?tab=notes`);
      }
      setTextNote('');
      showChangesSavedSnackbar();
      setOpen(false);
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent 
        className='w-[90%] h-full max-w-[700px] max-h-[350px] py-6 lg:py-4 px-5 lg:px-9 bg-white flex flex-col gap-0'
        onInteractOutside={e => e.preventDefault()}
      >
        <DialogHeader className="space-y-0 mx-auto">
          <DialogTitle className="text-xl font-bold">
            Add your text note
          </DialogTitle>
        </DialogHeader>
        <textarea 
          ref={textAreaRef}
          value={textNote}
          onChange={e => setTextNote(e.target.value)}
          className="h-full border-[1.3px] border-[#8F8F8F] rounded-lg p-3 resize-none 
          text-sm focus:ring-secondary focus:border-secondary mt-6 lg:mt-10 mb-6 max-h-[170px]"
        />
        <DialogFooter className="sm:justify-center">
          <Button
            variant="secondary"
            className='w-[200px] rounded-lg'
            onClick={() => addNote(Number(customerId))}
            disabled={!textNote || isLoading}
          >
            {isLoading ? <ThreeDotLoader /> : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
      AddTextNoteModal
    </Dialog>
  )
}

export default AddTextNoteModal